export default function Wordmark({ className = "h-4 w-auto", label = "green gate" }) {
  return (
    <svg viewBox="0 0 1603.596317 173.949525" className={className} role="img" aria-label={label} xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(-166.662104,341.871659) scale(0.100000,-0.100000)"
fill="currentColor" stroke="none">
<path d="M2415 3414 c-11 -2 -50 -11 -87 -20 -147 -33 -274 -102 -385 -208
-125 -118 -199 -238 -250 -403 -23 -78 -26 -104 -26 -233 0 -129 3 -155 27
-234 44 -146 107 -255 204 -358 97 -102 203 -175 312 -217 424 -163 889 11
1096 411 52 102 94 252 94 339 l0 59 -350 0 -351 0 3 -87 3 -88 249 -3 248 -2
-6 -26 c-13 -50 -68 -155 -113 -215 -90 -119 -230 -211 -381 -250 -92 -23
-240 -25 -332 -4 -222 52 -418 234 -496 460 -26 72 -28 93 -28 215 0 122 2
143 28 215 37 109 102 210 184 286 133 125 258 178 438 186 204 10 369 -50
522 -190 l42 -40 0 115 c0 134 2 131 -120 197 -120 64 -232 93 -380 97 -69 1
-134 1 -145 -2z"/>
<path d="M4110 3405 c-113 -23 -229 -71 -322 -133 l-38 -25 0 -783 0 -784 90
0 90 0 0 735 0 735 51 25 c167 85 414 86 589 2 27 -13 52 -22 55 -19 11 12 5
180 -7 189 -19 15 -134 50 -202 62 -79 15 -226 12 -306 -4z"/>
<path d="M5480 3405 c-188 -39 -345 -127 -474 -267 -154 -165 -231 -365 -230
-593 2 -298 148 -565 400 -728 74 -48 195 -101 257 -112 l37 -7 0 88 0 89 -64
23 c-158 57 -307 193 -381 347 -46 96 -60 144 -71 243 l-7 62 787 0 c432 0
786 3 786 8 0 4 -5 45 -10 91 -49 391 -336 692 -724 760 -79 15 -226 12 -306
-4z m334 -185 c165 -42 311 -145 405 -285 43 -65 91 -167 91 -195 0 -6 -246
-10 -665 -10 -419 0 -665 4 -665 10 0 26 47 127 89 192 89 137 241 245 403
288 100 26 241 26 342 0z"/>
<path d="M7480 3401 c-168 -38 -295 -106 -419 -225 -118 -114 -190 -234 -236
-393 -126 -434 118 -905 548 -1054 122 -43 117 -45 117 59 l0 87 -52 19 c-250
87 -440 326 -464 585 l-7 71 783 0 783 0 -6 83 c-4 45 -14 109 -22 142 -23 87
-107 250 -165 322 -107 133 -279 245 -450 294 -109 30 -297 35 -410 10z m352
-180 c139 -36 281 -125 365 -230 42 -52 133 -223 133 -250 0 -8 -177 -11 -670
-11 l-670 0 24 64 c78 207 280 386 487 431 96 20 242 19 331 -4z"/>
<path d="M9115 3404 c-94 -21 -200 -64 -279 -114 l-66 -42 2 -781 3 -782 88
-3 87 -3 0 735 0 736 25 16 c65 42 167 67 295 72 138 5 206 -7 312 -55 l58
-26 2 -736 3 -736 88 -3 87 -3 0 785 0 785 -42 29 c-65 44 -134 77 -228 107
-73 24 -106 28 -225 31 -101 3 -160 -1 -210 -12z"/>
<path d="M11820 3406 c-366 -82 -632 -359 -691 -720 -16 -102 -6 -270 21 -365
85 -299 323 -535 615 -612 520 -136 1047 232 1091 763 l7 78 -352 0 -352 0 3
-87 3 -88 248 -3 248 -2 -6 -23 c-4 -12 -25 -60 -48 -107 -33 -68 -59 -102
-127 -171 -138 -140 -265 -197 -455 -206 -134 -6 -224 11 -330 62 -246 118
-395 353 -395 625 0 274 148 509 395 626 100 48 174 64 291 64 176 0 320 -52
458 -166 l66 -54 0 114 0 115 -42 29 c-91 62 -213 110 -332 131 -78 14 -246
12 -316 -3z"/>
<path d="M13855 3403 c-158 -33 -296 -106 -413 -217 -183 -174 -275 -382 -276
-626 -2 -400 243 -728 631 -847 79 -24 104 -26 238 -26 134 0 159 2 238 26 90
28 181 70 249 114 l38 26 0 697 0 698 -66 42 c-83 52 -187 94 -286 114 -95 20
-259 19 -353 -1z m327 -174 c29 -6 86 -25 126 -41 l72 -30 0 -604 0 -604 -51
-25 c-79 -41 -190 -65 -294 -65 -319 0 -598 219 -676 530 -20 78 -17 259 5
340 64 237 269 437 505 495 69 17 242 19 313 4z"/>
<path d="M16661 3405 c-304 -69 -532 -257 -640 -527 -189 -470 52 -991 533
-1154 108 -37 106 -38 106 61 0 84 -1 86 -27 96 -103 41 -216 104 -266 150
-120 107 -204 265 -226 422 -6 43 -11 83 -11 88 0 5 310 9 786 9 l787 0 -7 71
c-26 263 -167 503 -379 648 -66 45 -199 105 -277 126 -90 23 -296 29 -379 10z
m397 -203 c199 -74 357 -234 427 -431 l14 -41 -671 0 -670 0 7 28 c12 49 74
166 120 224 86 109 226 200 369 239 57 15 95 18 196 15 109 -3 135 -7 208 -34z"/>
<path d="M15235 3393 c-11 -3 -44 -14 -72 -25 l-53 -19 0 -50 0 -49 -85 0 -85
0 0 -90 0 -90 85 0 85 0 0 -659 0 -660 54 -20 c98 -36 221 -54 342 -49 61 3
117 8 123 12 7 5 11 41 11 96 l0 90 -32 -8 c-42 -9 -278 -9 -300 0 -17 7 -18
45 -18 603 l0 595 175 0 175 0 0 90 0 90 -175 0 -175 0 0 75 c0 80 -1 81 -55
68z"/>
</g>
    </svg>
  );
}
